import Vue from 'vue'
import Vuex from 'vuex'
import sharedMutations from 'vuex-shared-mutations'

import user from './modules/user'
import project from './modules/project'
import session from './modules/session'
import socket from './modules/socket'
import notification from './modules/notification'
import message from './modules/message'
import component from './modules/component'
import modals from './modules/modals'
import post from './modules/post'
import comment from './modules/comment'
import category from './modules/category'
import poll from './modules/poll'
import award from './modules/award'
import region from './modules/region'
import iframe from './modules/iframe'
import pin from './modules/pin'
import partners from './modules/partners'
import partnerResources from './modules/partnerResources'
import utm from './modules/utm'
import onboarding from './modules/onboarding'
import navbar from './modules/navbar'
import judging from './modules/judging'
import projectPin from './modules/projectPin'
import contact from './modules/contact'
import fair from './modules/fair'
import questionVisibility from './modules/questionVisibility'
import projectNomination from './modules/projectNomination'
import judgeApplications from './modules/judgeApplication'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  plugins: [sharedMutations({
    sharingKey: 'pb-vms',
    predicate: user.sharedMutations
  })],
  state: {},
  actions: {},
  getters: {},
  mutations: {},
  modules: {
    user,
    project,
    session,
    socket,
    notification,
    message,
    component,
    modals,
    post,
    comment,
    category,
    poll,
    award,
    region,
    iframe,
    pin,
    partners,
    partnerResources,
    utm,
    onboarding,
    navbar,
    judging,
    projectPin,
    contact,
    fair,
    questionVisibility,
    projectNomination,
    judgeApplications
  },
  strict: debug
})
